import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class CardTitle extends PureComponent {
    render() {
        const {
            children,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['card-title']: true
        });

        return (
            <h4 className={classNames} {...props}>
                {children}
            </h4>
        );
    }
}

CardTitle.defaultProps = {};

export default CardTitle;
